import React, { useEffect, useRef, useState } from 'react';
import { InputNumber } from 'rsuite';

// One employee's manual retirement adjustment, in dollars.
//
// Simpler than the payroll correction cell: no reason is asked for, because
// this moves only what is remitted to the provider rather than what somebody is
// paid. Typing commits on blur; the stepper commits once a run of clicks has
// settled, so nudging it five times is one save.
//
// Part of the company-specific payroll module; see config/payrollFeature.js.

const STEPPER_SETTLE_MS = 600;

export default function PayrollAdjustmentCell({ employee, onSave, resetToken, disabled }) {
  const stored = Number(employee.retirement?.adjustment ?? 0);
  const [amount, setAmount] = useState(stored);

  const settleTimer = useRef(null);
  const dispatched = useRef(null);

  useEffect(() => {
    setAmount(stored);
    dispatched.current = null;
  }, [stored, resetToken]);

  useEffect(() => () => window.clearTimeout(settleTimer.current), []);

  const commit = (raw) => {
    window.clearTimeout(settleTimer.current);
    const next = raw === '' || raw == null ? 0 : Number(raw);
    if (!Number.isFinite(next)) { setAmount(stored); return; }
    if (next === stored || next === dispatched.current) return;
    dispatched.current = next;
    onSave(employee, next);
  };

  const handleChange = (value, event) => {
    setAmount(value);
    const tag = event?.target?.tagName;
    if (!tag || tag === 'INPUT') return;
    window.clearTimeout(settleTimer.current);
    settleTimer.current = window.setTimeout(() => commit(value), STEPPER_SETTLE_MS);
  };

  return (
    <div className="payroll-correction">
      <InputNumber
        value={amount}
        onChange={handleChange}
        onBlur={() => commit(amount)}
        onFocus={(event) => event.target.select()}
        onKeyDown={(event) => { if (event.key === 'Enter') event.target.blur(); }}
        disabled={disabled}
        size="sm"
        prefix="$"
        step={50}
        className="payroll-adjustment__input"
      />
    </div>
  );
}
